import { render, staticRenderFns } from "./ysText.vue?vue&type=template&id=d8193f94&scoped=true&"
import script from "./ysText.vue?vue&type=script&lang=js&"
export * from "./ysText.vue?vue&type=script&lang=js&"
import style0 from "./ysText.vue?vue&type=style&index=0&id=d8193f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8193f94",
  null
  
)

export default component.exports